module.exports = __webpack_public_path__ + "img/ic-btn-notification.8e1fd5de.svg";